// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1l7I2","boxTitle":"Qualiphy_boxTitle__1G5Ff","box":"Qualiphy_box__7HWME","toggleWrap":"Qualiphy_toggleWrap__1kMn3"};